import Event from 'ol/events/Event';

export class AsyncEvent extends Event {

  // This method needs to be called in the listener in order to take advantage of the async behaviour of this class.
  preventDefault (promise) {
    if (!this.propagationStopped) {
      super.preventDefault();
      this._promise = promise;
    }
  }

  getDefaultPreventedAsync () {
    return this._promise || Promise.resolve(this.propagationStopped);
  }

}
